module.exports = __webpack_public_path__ + "static/media/qrcode.ad6f59e7.svg";